export const AdminMenu = [
  {
    text: "Heat Map",
    subMenu: null,
    link: "/",
  },
  {
    text: "Price Compare",
    subMenu: null,
    link: "/price-compare",
  },
  {
    text: "Pricing Files",
    subMenu: null,
    link: "/pricing-files",
  },
  {
    text: "Manage Users",
    subMenu: null,
    link: "/manage-users",
  },
];
export const SubAdminMenu = [
  {
    text: "Heat Map",
    subMenu: null,
    link: "/",
  },
  {
    text: "Price Compare",
    subMenu: null,
    link: "/price-compare",
  },
  {
    text: "Pricing Files",
    subMenu: null,
    link: "/pricing-files",
  },
];
export const UserMenu = [
  {
    text: "Heat Map",
    subMenu: null,
    link: "/",
  },
];
